import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const TooltipFetchedObject = ({
  dataSourceDefinition,
  dataSourceProperty
}) => {
  const {
    label: dataSourceLabel
  } = dataSourceDefinition;
  const {
    label: propertyDisplayLabel
  } = dataSourceProperty;
  let message = 'automation-ui-formula-editor.data-passing-panel.single-value-input.tooltip.fetched_object.other';
  if (dataSourceDefinition.metadata && 'associationDefinition' in dataSourceDefinition.metadata) {
    message = 'automation-ui-formula-editor.data-passing-panel.single-value-input.tooltip.fetched_object.associated';
  }
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: message,
    options: {
      propertyDisplayLabel: /*#__PURE__*/_jsx("b", {
        children: propertyDisplayLabel
      }),
      dataSourceDisplayLabel: /*#__PURE__*/_jsx("b", {
        children: dataSourceLabel
      })
    }
  });
};
export default TooltipFetchedObject;